var _rect, _line, _circle, _circle2, _circle3, _rect2, _rect3, _path, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetInTouch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 247,
    viewBox: "0 0 558 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.217,
    y: 27.7236,
    width: 384.704,
    height: 283.859,
    rx: 28,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 115.76,
    y1: 160.765,
    x2: 487.848,
    y2: 160.765,
    stroke: "#EAEAEF",
    strokeWidth: 6.31958,
    strokeDasharray: "7.9 7.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.902,
    cy: 57.9123,
    r: 9.31851,
    fill: "#EAEAEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.449,
    cy: 57.9123,
    r: 9.31851,
    fill: "#EAEAEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.996,
    cy: 57.9123,
    r: 9.31851,
    fill: "#EAEAEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 419.125,
    y: 48.5938,
    width: 52.184,
    height: 20.5009,
    rx: 7.45486,
    fill: "#EAEAEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.23,
    x: 134.744,
    y: 89.6709,
    width: 59.7599,
    height: 16.8075,
    rx: 8.40373,
    fill: "#29315D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.143 98.0746C207.143 93.4334 210.906 89.6709 215.547 89.6709L317.508 89.6709C322.149 89.6709 325.911 93.4334 325.911 98.0746C325.911 102.716 322.149 106.478 317.508 106.478H215.547C210.906 106.478 207.143 102.716 207.143 98.0746Z",
    fill: "#EAEAEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.23,
    x: 134.744,
    y: 121.269,
    width: 59.7599,
    height: 16.8075,
    rx: 8.40373,
    fill: "#29315D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.145 129.672C207.145 125.031 210.907 121.269 215.548 121.269H442.098C446.739 121.269 450.501 125.031 450.501 129.672C450.501 134.314 446.739 138.076 442.098 138.076H215.548C210.907 138.076 207.145 134.314 207.145 129.672Z",
    fill: "#EAEAEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M450.723 129.672C450.723 125.031 454.485 121.269 459.126 121.269H459.698C464.339 121.269 468.102 125.031 468.102 129.672C468.102 134.314 464.339 138.076 459.698 138.076H459.126C454.485 138.076 450.723 134.314 450.723 129.672Z",
    fill: "#29315D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.611 191.769C135.611 187.128 139.374 183.365 144.015 183.365L364.096 183.365C368.738 183.365 372.5 187.128 372.5 191.769C372.5 196.41 368.738 200.173 364.096 200.173H144.015C139.374 200.173 135.611 196.41 135.611 191.769Z",
    fill: "#EAEAEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.611 219.636C135.611 214.994 139.374 211.232 144.015 211.232L255.096 211.232C259.738 211.232 263.5 214.994 263.5 219.636C263.5 224.277 259.738 228.039 255.096 228.039H144.015C139.374 228.039 135.611 224.277 135.611 219.636Z",
    fill: "#EAEAEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 134.55C5.87259 123.071 9.80559 108.393 21.2846 101.766L95.7974 58.7456C107.276 52.1182 121.955 56.0512 128.582 67.5302L172.444 143.502C179.072 154.981 175.139 169.659 163.66 176.287L89.1469 219.307C77.6679 225.934 62.9898 222.001 56.3623 210.522L12.5 134.55Z",
    fill: "#29315D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.291 141.789L73.5228 169.904C75.452 173.245 79.7211 174.389 83.0626 172.46L125.396 148.019C128.737 146.089 129.881 141.82 127.952 138.479L111.72 110.365",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.291 141.789L73.5228 169.904C75.452 173.245 79.7211 174.389 83.0626 172.46L125.396 148.019C128.737 146.089 129.881 141.82 127.952 138.479L111.72 110.365",
    stroke: "white",
    strokeWidth: 5.23774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.091 135.215L70.0264 108.776C71.2793 106.218 73.9555 104.673 76.7972 104.867L106.162 106.884C111.108 107.226 114.134 112.466 111.956 116.921L101.093 139.127C98.5892 144.246 93.2367 147.336 87.5516 146.946L62.8887 145.25C57.9389 144.911 54.9115 139.667 57.091 135.215Z",
    fill: "white",
    stroke: "#29315D",
    strokeWidth: 5.23774,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.091 135.215L70.0264 108.776C71.2793 106.218 73.9555 104.673 76.7972 104.867L106.162 106.884C111.108 107.226 114.134 112.466 111.956 116.921L101.093 139.127C98.5892 144.246 93.2367 147.336 87.5516 146.946L62.8887 145.25C57.9389 144.911 54.9115 139.667 57.091 135.215Z",
    stroke: "#29315D",
    strokeWidth: 6.26943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.135 124.111L81.3328 119.641L87.4686 130.268",
    stroke: "#29315D",
    strokeWidth: 6.1358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6105 131.92L89.9243 128.852",
    stroke: "#29315D",
    strokeWidth: 6.1358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8581 146.748L76.5121 177.896",
    stroke: "#29315D",
    strokeWidth: 6.26943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.429 145.033L102.281 136.688",
    stroke: "#29315D",
    strokeWidth: 6.26943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M399.651 97.9998C394.685 110.289 400.623 124.277 412.913 129.243L486.885 159.13C499.175 164.095 513.163 158.158 518.128 145.868L548.617 70.4059C553.582 58.1162 547.645 44.1283 535.355 39.163L461.382 9.27599C449.093 4.31064 435.105 10.2482 430.139 22.5378L399.651 97.9998Z",
    fill: "#29315D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.38 105.159L505.773 100.316C508.767 100.005 510.188 96.4862 508.253 94.1794L478.287 58.5214C476.027 55.8284 471.634 57.4106 471.638 60.9147L471.663 82.7653L456.249 98.8229C453.828 101.351 455.892 105.522 459.38 105.159Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M461.018 77.6062L487.906 88.4698",
    stroke: "#29315D",
    strokeWidth: 6.26943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M442.057 83.1557L447.62 85.4033",
    stroke: "white",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M442.796 71.3198L451.836 74.9722",
    stroke: "white",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M443.532 59.4853L456.049 64.5425",
    stroke: "white",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetInTouch);
export default __webpack_public_path__ + "static/media/get-in-touch.dae24d2006c9a4c02980b0253445ca91.svg";
export { ForwardRef as ReactComponent };